import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import configureStore, { history } from 'store/configureStore';

// Pages
import HomePage from 'pages/home';
import AboutPage from 'pages/about';
import ApiPage from 'pages/api';
import ContactPage from 'pages/contact';
import EmissionsPage from 'pages/products/emissions';
import RetinaPage from 'pages/products/retina';
import ForecastPage from 'pages/products/forecast';
import ToolsPage from 'pages/products/tools';
import LoginPage from 'pages/login';
import EmissionsDemoPage from 'pages/products/emissions/demo';
import RetinaDemoPage from 'pages/products/retina/demo';
import ForecastDemoPage from 'pages/products/forecast/demo';
import ToolsDemoPage from 'pages/products/tools/demo';
import StoriesPage from 'pages/stories';

// Components
import Header from './header';
import Footer from './footer';

import './style.css';

const store = configureStore();

const App = () => (
  <Provider store={store}>
    <Router hashType="slash">
      <ConnectedRouter history={history}>
        <div className="aq-app">
          <Header />

          <main className="aq-app-content" role="main">
            <Route exact path="/" component={HomePage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/about-us" component={AboutPage} />
            <Route path="/api" component={ApiPage} />
            <Route path="/stories" component={StoriesPage} />
            <Route path="/contact-us" component={ContactPage} />
            <Route exact path="/products/emissions/" component={EmissionsPage} />
            <Route exact path="/products/forecast-system/" component={ForecastPage} />
            <Route exact path="/products/forecast-system/demo" component={ForecastDemoPage} />
            <Route exact path="/products/retina/" component={RetinaPage} />
            <Route exact path="/products/tools/" component={ToolsPage} />
            <Route exact path="/products/emissions/demo" component={EmissionsDemoPage} />
            <Route exact path="/products/retina/demo" component={RetinaDemoPage} />
            <Route exact path="/products/tools/demo" component={ToolsDemoPage} />
          </main>
          <Footer />
        </div>
      </ConnectedRouter>
    </Router>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/app/index.js